// src/app/api/baseApi.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.token;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    // Try to refresh token
    const refreshResult = await baseQuery("/auth/refresh", api, extraOptions);

    if (refreshResult.data) {
      // Store the new token
      api.dispatch({ type: "auth/setToken", payload: refreshResult.data });
      // Retry the original query
      result = await baseQuery(args, api, extraOptions);
    } else {
      // Logout user
      api.dispatch({ type: "auth/logout" });
    }
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "Funnel",
    "FunnelStep",
    "LeadMagnet",
    "Product",
    "Lead",
    "LeadSegment",
    "EmailCampaign",
    "EmailTemplate",
    "EmailAutomation",
    "Order",
    "Analytics",
    "Settings",
    "User",
    "FaithLead",
    "CustomFunnelLead",
    "MonetizeKnowledgeLead",
    "Contacts",
    "AdminStats",
    "AdminOrder",
    "AdminUser",
    "FollowUp",
    "Timeline",
    "Tag",
  ],
  endpoints: () => ({}),
});
